<template lang="html">
  <div class="c2h4-div__upload">
    <div class="c2h4-div__preview">
      <canvas class="c2h4-img__preview" ref="preview"></canvas>
      <img :src="photo" alt="预览照片" ref="previewSrc" class="c2h4-img__preview" style="display: none;" />
    </div>
    <div class="c2h4-div__tips">
      <h4 class="c2h4-h4__tips__title">请确认照片：</h4>
    <ul class="c2h4-ul__tips" v-for="(tip, index) in tips" :key="index">
      <li class="c2h4-li__tip" v-html="tip"></li>
    </ul>
  </div>
  <div class="c2h4-div__btns">
    <input type="file" accept="image/*" capture="camera" style="display:none;" ref="getCamera"/>
    <button class="c2h4-button__re c2h4-btn" @click="reGetPhoto">重拍</button>
    <button class="c2h4-button__okay c2h4-btn" @click="subPhoto">确认</button>
  </div>
</div>
</template>

<script>
import EXIF from 'exif-js'
export default {
  beforeMount () {
    const {pic} = this.$store.state.photo
    const {photo} = pic
    if (!pic) {
      window.location = '/c2h42baidu/'
    }
    this.photoFile = photo
  },
  mounted () {
    this.previewPhoto()
  },
  watch: {
    photoFile: function (data) {
      this.$store.dispatch({
        type: 'storePhoto',
        photo: data
      })
    }
  },
  methods: {
    previewPhoto () {
      const file = this.photoFile
      const img = this.$refs['previewSrc']
      const preview = this.$refs['preview']
      let reader = new FileReader()
      if (file) {
        reader.readAsDataURL(file)
        reader.onload = (arg) => {
          this.photo = arg.target.result
          img.onload = () => {
            let imgWidth = img.width
            let imgHeight = img.height
            let ctx = preview.getContext('2d')
            this.fixPhotoOrientation({file, img, ctx, preview, imgWidth, imgHeight})
          }
        }
      }
    },
    fixPhotoOrientation (params) {
      let {file, img, ctx, preview, imgWidth, imgHeight} = params
      let ctxWidth = imgWidth
      let ctxHeight = imgHeight
      let orientation
      EXIF.getData(file, function () {
        orientation = EXIF.getAllTags(this).Orientation
        preview.width = imgWidth
        preview.height = imgHeight
        if (orientation === 6) {
          ctx.translate(preview.width / 2, preview.height / 2)
          ctx.rotate(Math.PI / 2)
          ctx.drawImage(img, -ctxHeight / 2, -ctxWidth / 2, imgHeight, imgWidth)
        } else {
          ctx.drawImage(img, 0, 0, imgWidth, imgHeight)
        }
      })
    },
    reGetPhoto () {
      this.eventCount++
      const camera = this.$refs.getCamera
      const event = new MouseEvent('click', {
        'view': window,
        'bubbles': false,
        'cancelable': true
      })
      window.BD_MMS_SKILL.sendLog()
      if (camera.dispatchEvent(event) && this.eventCount <= 1) {
        camera.addEventListener('change', (e) => {
          this.photoFile = e.target.files[0]
          this.previewPhoto()
        })
      }
    },
    subPhoto () {
      window.BD_MMS_SKILL.sendLog()
      this.$store.state.photo.pic.photo && this.$router.push('/loading')
    }
  },
  data () {
    return {
      eventCount: 0,
      photo: '',
      photoFile: '',
      tips: ['1）使用<span class="green">后置摄像头</span>拍摄', '2）开启<span class="green">闪光灯模式</span>，拍照时请闭眼', '3）确保照片<span class="green">清晰</span>，人脸<span class="green">正面居中</span>']
    }
  }
}
</script>

<style scoped>
.c2h4-div__upload{
  width: 100%;
}
.c2h4-div__preview{
  width: 52vw;
  height: 69.333333333vw;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10.66666667vw;
  margin-bottom: 10.66666667vw;
  background-color: #e3e3e3;
}
.c2h4-img__preview{
  width: 100%;
  height: 69.333333333vw;
}
.c2h4-div__tips{
  width: 54.5vw;
  margin-left: auto;
  margin-right: auto;
  font-family: 'PingFangSC';
}
.c2h4-ul__tips{
  margin: 0;
  padding:0;
  list-style-type: none;
  font-size: 3.46666667vw;
  color: #646464;
}
.c2h4-li__tip{
  margin-top: 5.86666667vw;
}
.c2h4-h4__tips__title{
  margin:0;
  color: #646464;
  font-weight: normal;
  font-size: 3.46666667vw;
}
.c2h4-div__btns{
  margin-top: 10.666666667vw;
  padding: 0 8vw;
}
.c2h4-btn{
  width:33.86666667vw;
  height: 12.26666667vw;
  background-color: #64c8c8;
  border-radius: 6.133333333vw;
  border:none;
  outline: none;
  font-size: 5.6vw;
  color: #fff;
}
.c2h4-button__okay{
  float: right;
}
</style>
<style>
.green{
  color: #64c8c8;
}
</style>



// WEBPACK FOOTER //
// src/components/Upload/index.vue